import type { RefObject } from 'react';
import { UNSAFE_PortalProvider } from 'react-aria';
import type { PopoverProps } from 'react-aria-components';
import { Popover as BasePopover } from 'react-aria-components';

type Props = {
  triggerRef: RefObject<HTMLDivElement | null>;
} & Omit<PopoverProps, 'triggerRef'>;

export const Popover = (props: Props) => {
  const { triggerRef } = props;

  if (!triggerRef.current) {
    return null;
  }

  return (
    <UNSAFE_PortalProvider getContainer={() => triggerRef.current}>
      <BasePopover
        {...props}
        style={{
          width: '100%',
          ...props.style
        }}
      />
    </UNSAFE_PortalProvider>
  );
};
